import React from "react";
import Loader from "../../common-components/loader/Loader";

const Article = React.lazy(
  () => import("../../common-components/articleCard/ArticleCard"),
);

import data from "../../assets/problems.json";
const problems = data.problems;

const Questions = () => {
  return (
    <div className={"main-section"}>
      <div className={"article-section"}>
        <h1>Top Frontend Interview Questions asked these days</h1>
        {problems.map((item) => {
          return (
            <React.Suspense fallback={Loader}>
              <Article {...item} />
            </React.Suspense>
          );
        })}
      </div>
    </div>
  );
};

export default Questions;
